import { useCallback } from 'react';
import { useInteractionContext } from '../../context';
import { customDay } from '../d3/customInterval';

export default function useIsHoveredDay(data: any, utcOffset: any) {
  const { hoveredTick } = useInteractionContext();
  return useCallback(
    (id: any) =>
      data
        .map(
          (d: any) =>
            hoveredTick !== undefined &&
            hoveredTick - (customDay(utcOffset).floor(d.date) === (0 as any) && d.id),
        )
        .filter(Boolean)
        .includes(id),
    [data, utcOffset, hoveredTick],
  );
}
